import React from 'react';
import cn from 'classnames';
import PropTypes from 'prop-types';

import styles from '../DashboardView.scss';

const Nocontentfound = props => (
  <div className={cn('col s12', styles.emptyScreens)}>
    <div className={styles.emptyImage}>
      <img src="https://media.dev.myrecruitboard.com/Images/no-content-found%403x.png" alt="empty screen" />
    </div>
    <br /> <br />
    {props.text}
  </div>
);

Nocontentfound.propTypes = {
  text: PropTypes.string.isRequired,
};

export default Nocontentfound;



// WEBPACK FOOTER //
// ./src/components/DashboardView/Tutorial/Nocontentfound.js